import { render, staticRenderFns } from "./PosN.vue?vue&type=template&id=bfbad9f0&scoped=true"
import script from "./PosN.vue?vue&type=script&lang=js"
export * from "./PosN.vue?vue&type=script&lang=js"
import style0 from "./_layout.css?vue&type=style&index=0&id=bfbad9f0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbad9f0",
  null
  
)

export default component.exports